import { render, staticRenderFns } from "./quicktable.vue?vue&type=template&id=466938e5&scoped=true&"
import script from "./quicktable.vue?vue&type=script&lang=js&"
export * from "./quicktable.vue?vue&type=script&lang=js&"
import style0 from "./quicktable.vue?vue&type=style&index=0&id=466938e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466938e5",
  null
  
)

export default component.exports